/*
 *@Description: 子系统选择面板
 *@Author: guzhengguang
 *@Date: 2019-04-26 18:20:53
*/
<template>
  <div class="alarmTypeCard">
    <i class="el-icon-close"
       @click="handleTypeCardClose"></i>
    <dl>
      <dt>
        <el-checkbox :indeterminate="isIndeterminate"
                     v-model="checkAll"
                     @change="handleCheckAllChange">
          {{$t('realTimeAlarm.button.whole')}}
        </el-checkbox>
      </dt>
      <dd>
        <el-checkbox-group v-model="checkedTypes"
                           @change="handleCheckedCitiesChange">
          <el-checkbox v-for="type in types"
                       :label="type.value"
                       :key="type.value">
            {{type.label}}
          </el-checkbox>
        </el-checkbox-group>
      </dd>
    </dl>
    <div class="alarmTypeFoot">
      <el-button type="primary"
                 @click="handleSearchType">
        {{$t('realTimeAlarm.button.conform')}}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Dic } from '$utils'
export default {
  props: {
    data: {
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      checkAll: false,
      checkedTypes: [],
      types: [],
      isIndeterminate: false,
        selectedSubSystem:[]
    }
  },
  watch: {
    data(newVal, oldVal) {
      const _this = this
        this.selectedSubSystem = newVal;
      _this.types = []
      _.map(newVal, o => {
        const alarmTypes = Dic.find('SENU004', {
          relation: o
        })
        _this.types = _this.types.concat(alarmTypes)
      })
    }
  },
  mounted() {
    if (this.data.length === 0) {
      _.map(_.map(Dic.find('SENU004'), 'value'), o => {
        const alarmTypes = Dic.find('SENU004', {
          relation: o
        })
        this.types = this.types.concat(alarmTypes)
      })
    }
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedTypes = val ? this.types.map(item => item.value) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.types.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.types.length
    },
    handleTypeCardClose() {
      this.$emit('cardClose')
        this.checkedTypes = []
        this.checkAll = false
        this.isIndeterminate = false
    },
    handleSearchType() {
        if(this.checkedTypes.length ===0){
            this.$message.warning(this.$t('realTimeAlarm.message.alarmType'))
        }else{
            var tmpArr = [];
            const checkeds = _.map(this.checkedTypes, item => {
                return item + ''
            })
            this.selectedSubSystem.map(item => {
                if(this.selectedSubSystem.length){
                    for (let i = 0, len = checkeds.length; i < len; i++){
                        let str = checkeds[i];
                        if(str[0] == item){
                            tmpArr.push(checkeds[i]);
                        }
                    }
                }
            });            
            this.$emit('searchType', tmpArr)
            this.$emit('cardCloseCon')
            this.$emit('cardClose')
            this.checkedTypes = []
            this.checkAll = false
            this.isIndeterminate = false
        }
    }
  }
}
</script>

